/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { currentProductPrice } from "../functions/currentProductPrice";
import "../styles/global.css";
import { EnvContext } from "../context/EnvContext";
import { logAnalyticsEvent } from "../firebase/firebaseConfig";
import PriceDisplay from "../elements/ProductPrice";
import ListItem_Ribbon from "./ListItem_Ribbon";
import isProductAvailable from "../functions/isProductAvailable";

const ListItem_Favorites = ({ product, displayType = "vertical", priceTheme, ribbonSettings, available }) => {
  const environment = useContext(EnvContext);
  const navigate = useNavigate();
  const [priceInfo, setPriceInfo] = useState({});

  useEffect(() => {
    const fetchPriceInfo = async () => {
      const result = await currentProductPrice(product);
      setPriceInfo(result);
    };

    fetchPriceInfo();
  }, [product]);

  const saveScrollPosition = () => {
    const scrollY = window.scrollY;
    localStorage.setItem("ShopPageScrollPosition", scrollY);
  };

  const handleNavigate = () => {
    logAnalyticsEvent("select_content", {
      content_type: "product",
      item_id: product.seller_product_id,
      item_name: product.product_name,
      environment: environment,
    });
    saveScrollPosition();
    navigate(`/Listing/${product?.seller_product_id}`);
  };

  let renderBrand = <div style={{ ...styles.productBrand }}>{product?.brand_name}</div>;
  let renderName = (
    <h3
      style={{
        ...styles.productName,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: 0,
        marginTop: 10,
      }}
    >
      {product?.product_name || ""}
    </h3>
  );

  return (
    <div
      style={{
        ...styles.listItemContainer,
        opacity: !isProductAvailable(product) ? 0.8 : 1,
        padding: "0 20px",
      }}
    >
      <div
        style={{ ...styles.listItem, position: "relative", height: "100%", marginBottom: 20 }}
        onClick={() => {
          handleNavigate();
        }}
      >
        {displayType === "vertical" && <ListItem_Ribbon product={product} priceInfo={priceInfo} ribbonSettings={ribbonSettings} />}
        <div
          style={{
            display: "flex",
            position: "relative",
            height: "100%",
            padding: "0px 0px",
          }}
        >
          {displayType === "vertical" && <ListItem_Ribbon product={product} priceInfo={priceInfo} ribbonSettings={ribbonSettings} />}
          <div
            style={{
              display: "flex",
              flex: 1,
              height: "100% !important",
            }}
          >
            <div style={{ ...styles.listItemImageContainer, borderRadius: "8px", background: available ? "#f5f5f5" : "#7b7b7b" }}>
              {displayType !== "vertical" && <ListItem_Ribbon product={product} priceInfo={priceInfo} ribbonSettings={ribbonSettings} />}

              <img
                src={product?.images && product?.images?.length > 0 ? product?.images[0] : "/images/no_product_image.png"}
                alt={product?.name || "Product"}
                style={{
                  ...styles.listItemImage,
                  opacity: !available ? 0.3 : 1,
                  objectFit: "cover",
                  filter: !available ? "grayscale(100%)" : "none",
                }}
                onLoad={(e) => {
                  e.target.style.opacity = 1;
                }}
                onError={(e) => {
                  e.target.src = "/images/no_product_image.png";
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              width: "100%",
              justifyContent: "flex-start",
              alignContent: "flex-start",
              alignItems: "flex-start",
              height: "100%",
              padding: displayType === "vertical" ? "0px 5px" : "5px 5px",
            }}
          >
            <div style={{ ...styles.listItemContent, ...styles.productPrice, width: "100%", height: "100%", display: "flex" }}>
              {displayType === "vertical" ? (
                <>
                  <div style={{ ...styles.addToBag.priceSection, padding: 0 }}>
                    {priceInfo ? <PriceDisplay priceInfo={priceInfo} priceTheme={priceTheme} /> : null}
                  </div>
                  {renderBrand}
                  {renderName}
                </>
              ) : (
                <div style={{ height: "100%" }}>
                  <div
                    style={{
                      height: "calc(100% - 50px)",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", paddingLeft: 10 }}>
                      <div style={{}}>
                        {renderBrand}
                        {renderName}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  listItemContainer: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    cursor: "pointer",
    maxWidth: "570px",
  },
  listItemImageContainer: {
    display: "flex",
    position: "relative",
    width: "100%",
    background: "#f5f5f5",
    aspectRatio: "1 / 1",
    overflow: "hidden",
  },
  listItemImage: {
    display: "flex",
    objectFit: "contain",
    width: "100%",
    height: "100%",
  },
  listItemContent: {
    display: "flex",
    flexDirection: "column",
  },
  productPrice: {
    color: "black",
    fontWeight: "700",
    fontSize: "1rem",
  },
  productBrand: {
    fontSize: "1rem",
    fontWeight: "800",
    color: "black",
    marginBottom: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
  },
  productName: {
    fontSize: "1rem",
    fontWeight: "300",
    color: "black",
    marginTop: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
};

export default ListItem_Favorites;
